import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';


// Scrolls to the top when the pathname changes (not on the first render).
const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation();
  const previousPathname = useRef(pathname);
  useEffect(() => {
    if (previousPathname.current !== pathname) {
      previousPathname.current = pathname;
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return children;
};

export default ScrollToTop;
